import { render, staticRenderFns } from "./OldVersionRedirect.vue?vue&type=template&id=049425e0&"
import script from "./OldVersionRedirect.vue?vue&type=script&lang=js&"
export * from "./OldVersionRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports